import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type AudiSalesForceModuleSpecsFragment } from '../../../../api/fragments/AudiSalesForceModuleSpecs';
import InputField from '../../../../components/fields/InputField';
import PasswordField from '../../../../components/fields/PasswordField';
import SelectField from '../../../../components/fields/SelectField';
import SingleSecretUploadField from '../../../../components/fields/SingleSecretUploadField';
import useModuleOptions from '../modules/implementations/shared/useModuleOptions';

const StyledContainer = styled(Row)`
    background-color: #fff;
    padding: 20px;
`;

type Props = {
    module: AudiSalesForceModuleSpecsFragment;
};

const AudiSalesForceModuleUpdateForm = ({ module }: Props) => {
    const { t } = useTranslation(['moduleDetails']);

    const { company } = module;

    const { tradeIn: tradeInOptions } = useModuleOptions(company);

    return (
        <StyledContainer gutter={10}>
            <Col md={8} xs={24}>
                <InputField
                    {...t('moduleDetails:fields.displayName', {
                        returnObjects: true,
                    })}
                    name="displayName"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <SelectField
                    {...t('moduleDetails:fields.tradeInModuleId', {
                        returnObjects: true,
                    })}
                    name="setting.tradeInModuleId"
                    options={tradeInOptions}
                    showSearch
                />
            </Col>
            <Col md={8} xs={24}>
                <InputField
                    {...t('moduleDetails:fields.baseUrl', {
                        returnObjects: true,
                    })}
                    name="setting.baseUrl"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <InputField
                    {...t('moduleDetails:fields.clientId', {
                        returnObjects: true,
                    })}
                    name="setting.clientId"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <PasswordField
                    {...t('moduleDetails:fields.clientSecret', {
                        returnObjects: true,
                    })}
                    name="setting.clientSecret"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <SingleSecretUploadField
                    {...t('moduleDetails:fields.authority', { returnObjects: true })}
                    name="setting.authority"
                />
            </Col>
            <Col md={8} xs={24}>
                <SingleSecretUploadField
                    {...t('moduleDetails:fields.publicCert', { returnObjects: true })}
                    name="setting.publicCert"
                />
            </Col>
            <Col md={8} xs={24}>
                <SingleSecretUploadField
                    {...t('moduleDetails:fields.privateKey', { returnObjects: true })}
                    name="setting.privateKey"
                />
            </Col>
        </StyledContainer>
    );
};

export default AudiSalesForceModuleUpdateForm;
